import React from "react";
import Bundles from "../../components/Shop/Bundles";

const ProfileBundles = () => {
  return <Bundles />;
};

export default ProfileBundles;

